export default __webpack_public_path__ + "static/media/apple.83af90e6.png";